import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import TextArea from 'react-expanding-textarea';
import classnames from 'classnames';
import './note_form.scss';
import _ from 'lodash';

class NoteForm extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = { note: this.props.note || '' };
  }

  onChange(e) {
    this.setState({ note: e.target.value });
  }

  save() {
    this.props.onSave(this.state.note);
  }

  cancel(e) {
    _.invoke(e, 'preventDefault');
    _.invoke(this.props, 'onCancel');
  }

  render() {
    return (
      <div className={classnames('note-form', this.props.className)}>
        <TextArea
          autoFocus
          className="form-control"
          id="note_form"
          onChange={this.onChange}
          placeholder="Enter note..."
          required
          value={this.state.note}
        />
        <Button color="primary" onClick={this.save}>
          Save Note
        </Button>
        <Button color="link" onClick={this.cancel}>
          Cancel
        </Button>
      </div>
    );
  }
}

NoteForm.propTypes = {
  className: PropTypes.string,
  note: PropTypes.string,
  onSave: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  onCancel: PropTypes.func,
};

export default NoteForm;
